import React, { useState } from 'react';
import { useTheme } from '../utils/ThemeContext';
import { Link } from 'react-router-dom';

const Section = ({ title, children, theme }) => {
    const [open, setOpen] = useState(false);
    return (
        <div>
            <div
                onClick={() => setOpen(o => !o)}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '4px 12px',
                    backgroundColor: theme.primary,
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#fff',
                    userSelect: 'none',
                }}
            >
                <span>{title}</span>
                <span style={{ fontSize: '10px' }}>{open ? '▲' : '▼'}</span>
            </div>
            {open && (
                <div style={{ padding: '4px 12px 8px', fontSize: '12px', color: theme.bodyText }}>
                    {children}
                </div>
            )}
        </div>
    );
};

export const ResultsDetail = ({datePlayed, course, numPlayers, netWinner, grossWinner, netWinnerNet, netWinnerGross, grossWinnerGross, twoDollarSkins, fiveDollarSkins, closestToPin}) => {
    const { theme } = useTheme();

    const cellSx = { paddingRight: '12px', whiteSpace: 'nowrap' };

    const twoDollarRows = () => {
        if (JSON.stringify(twoDollarSkins) === '[[]]') {
            const amount = numPlayers * 2;
            return <tr><td>No Winners. ${amount} carries over</td></tr>;
        }
        return twoDollarSkins.map((p, i) => (
            <tr key={i}><td style={cellSx}>{p.name}</td><td style={cellSx}>hole {p.holeNum}</td><td>${p.amount}</td></tr>
        ));
    };

    const fiveDollarRows = () => {
        if (JSON.stringify(fiveDollarSkins) === '[[]]') {
            return <tr><td>No Winners. Pot carries over</td></tr>;
        }
        return fiveDollarSkins.map((p, i) => (
            <tr key={i}><td style={cellSx}>{p.name}</td><td style={cellSx}>hole {p.holeNum}</td><td>${p.amount}</td></tr>
        ));
    };

    const ctpRows = () => {
        if (JSON.stringify(closestToPin) === '[[]]') {
            return <tr><td>No Closest To Pins</td></tr>;
        }
        return closestToPin.map((p, i) => (
            <tr key={i}><td style={cellSx}>{p.name}</td><td>hole {p.holeNum}</td></tr>
        ));
    };

    return (
        <div style={{ backgroundColor: theme.rowBg, fontSize: '12px' }}>
            {/* Summary row — always visible */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
                gap: '4px 16px',
                padding: '6px 12px',
                color: theme.bodyText,
            }}>
                <span><span style={{ color: theme.primary, fontWeight: 'bold' }}>Course: </span>{course}</span>
                <span><span style={{ color: theme.primary, fontWeight: 'bold' }}>Players: </span>{numPlayers}</span>
                <span><span style={{ color: theme.primary, fontWeight: 'bold' }}>Low Net: </span>{netWinner} ({netWinnerNet} net, {netWinnerGross} gross)</span>
                <span><span style={{ color: theme.primary, fontWeight: 'bold' }}>Low Gross: </span>{grossWinner} ({grossWinnerGross})</span>
            </div>

            {/* Collapsible sections */}
            <Section title="$2 Skins" theme={theme}>
                <table><tbody>{twoDollarRows()}</tbody></table>
            </Section>
            <Section title="$5 Skins" theme={theme}>
                <table><tbody>{fiveDollarRows()}</tbody></table>
            </Section>
            <Section title="Closest to Pin" theme={theme}>
                <table><tbody>{ctpRows()}</tbody></table>
            </Section>

            {/* Scoreboard link */}
            <div style={{ padding: '6px 12px 8px' }}>
                <Link
                    style={{ color: theme.primary, fontWeight: 'bold', fontSize: '12px' }}
                    to={{ pathname: '/weeklyscoreboard', search: `?datePlayed=${datePlayed}` }}
                    onClick={(e) => e.stopPropagation()}
                >
                    View Scoreboard →
                </Link>
            </div>
        </div>
    );
};

export default ResultsDetail;
